var map = {
	"./argentina/sectionOrders.json": [
		38312,
		8312
	],
	"./australia/sectionOrders.json": [
		28187,
		8187
	],
	"./austria/sectionOrders.json": [
		58646,
		8646
	],
	"./bangladesh/sectionOrders.json": [
		58516,
		8516
	],
	"./belgium/sectionOrders.json": [
		73636,
		3636
	],
	"./canada/sectionOrders.json": [
		36599,
		6599
	],
	"./chile/sectionOrders.json": [
		53080,
		3080
	],
	"./china/sectionOrders.json": [
		88162,
		8162
	],
	"./czechrepublic/sectionOrders.json": [
		65854,
		5854
	],
	"./greece/sectionOrders.json": [
		65618,
		5618
	],
	"./italy/sectionOrders.json": [
		23474,
		3474
	],
	"./kenya/sectionOrders.json": [
		9409,
		9409
	],
	"./morocco/sectionOrders.json": [
		551,
		551
	],
	"./multiService/sectionOrders.json": [
		92833,
		2833
	],
	"./netherlands/sectionOrders.json": [
		98653,
		1034
	],
	"./peru/sectionOrders.json": [
		56275,
		6275
	],
	"./poland/sectionOrders.json": [
		99537,
		9537
	],
	"./slovakia/sectionOrders.json": [
		84897,
		4897
	],
	"./southafrica/sectionOrders.json": [
		34394,
		4394
	],
	"./switzerland/sectionOrders.json": [
		56312,
		6312
	],
	"./thailand/sectionOrders.json": [
		69298,
		9298
	],
	"./unitedkingdom/sectionOrders.json": [
		37101,
		7101
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 15299;
module.exports = webpackAsyncContext;